/* eslint-disable */
export default {
  to: '宛先：',
  enterNameOrPhoneNumber: '番号の入力',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
